import { styled as o } from "styled-components";
import { Dropdown as e } from "../../modules/Dropdown/index.js";
import { Colors as n } from "../../styles/colors/index.js";
import { Theme as r } from "../../styles/themes/index.js";
import { CaptionHeavy as t, Caption as i } from "../../styles/typography/index.js";
import { MediaQuery as c } from "../../styles/variables.js";
import { Icon as a } from "../Icon/index.js";
const u = o(e.Item)`
  && {
    justify-content: flex-start;
    align-items: center;
    border: 0;
    border-radius: 0;
    height: unset;
    flex: inherit;
    padding: 12px 20px;

    ${t}

    &:hover {
      background: rgb(${r.colors.Papa});
    }

    & > i {
      font-size: 24px;
      margin-right: 8px;
      color: rgb(${r.colors.Brand});
    }

    & > svg {
      width: 16px;
      height: 16px;
      margin: 0 12px 0 4px;
      fill: rgb(${r.colors.Brand});
    }

    @media ${c.SCREEN_MD_UP} {
      flex: 1 0 auto;
      padding: 12px 20px;
    }
  }
`, p = o(a)`
  font-size: 18px;
  color: rgb(${r.colors.Alpha});
`, x = o(
  e.Item
)`
  && {
    justify-content: space-between;
    border: 0;
    border-radius: 0;

    span {
      margin-left: 32px;
    }

    ${i}

    &[aria-selected='true'] {
      ${t}
      background: rgb(${r.colors.Quebec});
    }

    &:hover {
      background: rgb(${r.colors.Papa});
    }
  }
`, h = o(p)`
  color: rgb(${n.Green});
`;
export {
  p as UserMenuAccordionIcon,
  x as UserMenuAccordionItemContainer,
  h as UserMenuAccordionSelectedIcon,
  u as UserMenuItemContainer
};
